import { useEffect, useState } from "react";
import { ordresApi } from "@services/api/ordres";
import type { Ordre } from "types/ordre";

/**
 * Tous les ordres notés par le client (Réglages → Avis clients, widget Satisfaction).
 *
 * Lus au serveur (`GET /ordres?rated=true`) et non filtrés dans le store des ordres :
 * le store ne porte qu'une page de la liste, et un avis laissé sur un ordre hors de
 * cette page n'apparaissait jamais (« Aucun avis pour le moment », Jérôme 2026-10-14).
 * Le filtre local reste en garde-fou.
 */
export function useRatedOrdres(orgId?: string): { ordres: Ordre[]; loading: boolean } {
  const [ordres, setOrdres] = useState<Ordre[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orgId) return;
    let alive = true;
    setLoading(true);
    ordresApi
      .list({ org_id: orgId, rated: true, limit: 1000 })
      .then(({ items }) => {
        if (alive) setOrdres(items.filter((o) => o.client_rating != null && o.client_rating > 0));
      })
      .catch(() => { if (alive) setOrdres([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [orgId]);

  return { ordres, loading };
}
